import { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

export function useSiteContent() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent(data);
    } catch (e) {
      console.error("content load failed", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { content, loading, reload: load, setContent };
}
